import React, { Suspense } from 'react';
import type { FC, ReactNode } from 'react';

import { SuspenseContext } from './SuspenseContext';

export type AlloySuspendable = {
  emitSuspenseEvents?: boolean;
};

type OptionalSuspenseWrapperProps = AlloySuspendable & {
  fallback: NonNullable<ReactNode> | null;
  children?: ReactNode;
};

const AlloySuspense: FC<OptionalSuspenseWrapperProps> = ({
  emitSuspenseEvents = false,
  fallback,
  children = null,
}) =>
  emitSuspenseEvents ? (
    children
  ) : (
    <SuspenseContext.Provider value={{ hasSuspenseWrapper: true }}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </SuspenseContext.Provider>
  );
export default AlloySuspense;
